var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.955 11.185L15.88 11.71C14.0609 8.0792 11.7767 4.70079 9.085 1.66V20.04H7.885V1.71C5.28936 4.81281 3.00348 8.16209 1.06 11.71L0 11.17C2.13903 7.25653 4.68477 3.57953 7.595 0.2L7.77 0H9.18L9.355 0.18C12.4046 3.46356 14.9644 7.17011 16.955 11.185Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrow-up.84e06b0542c6762c3c674e2ba709ec7b.svg";
export { ForwardRef as ReactComponent };